import { useMemo } from 'react'

import AppStore from '@v4/store/appStore'
import { getOverallScore, getTier } from '@v4/utils'
import { useScoreFormat } from '@v4/hooks/index'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useSectionId } from '@v4/components/common/SectionItem'

export default ({ useCustomScoreColor, group, scoreTextPrimary, scoreFormat }) => {
	const tiers = AppStore.useStoreState(state => state.scoreTiers)
	const result = AppStore.useStoreState(state => state.result.data)
	const sectionId = useSectionId()
	const activeTierId = PageBuilderSelector.useMetaItemActiveTierId({ sectionId, group })

	const { score_percent: percent, score } = useMemo(() => {
		return getOverallScore(result.scores)
	}, [result.scores])

	const { score_colour: color, name: tierName, id } = useMemo(() => {
		return getTier(tiers, percent, activeTierId) || {}
	}, [activeTierId, percent, tiers])

	const customColor = useCustomScoreColor && scoreTextPrimary
	const scoreColor = customColor || color

	const totalScore = useScoreFormat(scoreFormat, percent, score, { withDenominator: true })

	return { scoreColor, totalScore, tierName, tiers, percent, activeTierId: id }
}
